export default __webpack_public_path__ + "static/media/warningRed.fa616824.svg";